module.exports = __webpack_public_path__ + "img/PETS.4f9b7930.png";